import { Method } from 'axios';

export const API_METHOD_POST: Method = 'POST';
export const API_METHOD_GET: Method = 'GET';
export const API_METHOD_PUT: Method = 'PUT';
export const API_METHOD_PATCH: Method = 'PATCH';
export const API_METHOD_DELETE: Method = 'DELETE';

const BASE_API_URL =
  process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000/api';

const API_VERSION = process.env.NEXT_PUBLIC_API_VERSION || '/v1';

export const API_URL = `${BASE_API_URL}${API_VERSION}`;

export const API_AUTH_LOGIN_URL = `${API_URL}/auth/login`;
export const API_AUTH_LOGOUT_URL = `${API_URL}/auth/logout`;

export const API_AUTH_REFRESH_TOKEN_URL = `${API_URL}/auth/refresh-token`;

export const API_REGISTER_URL = `${API_URL}/onboarding-team-members`;

//PROFILE APIS
export const API_PROFILE_DETAILS_UPDATE = `${API_URL}/profile`;
export const API_PROFILE_PASSWORD_UPDATE = `${API_URL}/profile/change-password`;
export const API_PROFILE_PASSWORD_CHECKER = `${API_URL}/profile/check-password`;
export const API_PROFILE_GET_USER = `${API_URL}/profile/get-user`;
export const API_PROFILE_GET_STRIPE_KEY = `${API_URL}/profile/get-stripe-key`;
export const API_PROFILE_CONNECT_STRIPE = `${API_URL}/profile/connect`;
export const API_PROFILE_COOKIES_CONSENT = `${API_URL}/profile/cookies-consent`;

// COMPANY APIS
export const API_COMPANY_SOCIAL_LINK_UPDATE_URL = `${API_URL}/company/settings/social-links-update`;

export const API_COMPANY_TAX_RATES = `${API_URL}/company/tax-rates`;

export const API_COMPANY_SETTINGS_TAX_DETAILS_UPDATE = `${API_URL}/company/settings/tax-details-update`;

export const API_COMPANY_SETTINGS_UPDATE = `${API_URL}/company/settings/update`;

export const API_COMPANY_SETTINGS = `${API_URL}/company/settings`;

export const API_COMPANY_DELETE_LOGO = `${API_URL}/company/settings/logo-delete`;
export const API_COMPANY_DELETE = `${API_URL}/company/settings/delete-company`;
export const API_COMPANY_DELETE_CANCEL = `${API_URL}/company/settings/cancel-delete-company`;

export const API_COMPANY_PAYMENT_INTEGRATION = `${API_URL}/company/payment-integrations`;

export const API_COMPANY_ACCOUNTING_INTEGRATION = `${API_URL}/company/settings/xero-settings`;

export const API_GET_XERO_STATUS = `${API_URL}/xero/status`;

export const API_DISCONNECT_XERO = `${API_URL}/xero/disconnect`;

export const API_XERO_AUTH = `${API_URL}/xero/auth`;
// Xero authorization URL endpoint (redirect bootstrap)
export const API_XERO_CONNECT = `${API_URL}/xero/connect`;

// COMMON APIS
export const API_COMMON_PUBLIC_KEY_URL = `${API_URL}/common/public_key`;

export const API_COMMON_UPLOAD_FILE = `${API_URL}/common/upload-file`;

export const API_COMMON_TIMEZONES = `${API_URL}/common/timezones`;

export const API_COMMON_DATE_FORMATS = `${API_URL}/common/date-formats`;

export const API_COMMON_TIME_FORMATS = `${API_URL}/common/time-formats`;

export const API_COMMON_DAY_OF_WEEK = `${API_URL}/common/days-of-weeks`;

export const API_COMMON_COUNTRIES = `${API_URL}/common/countries`;

export const API_COMMON_TEAMMEMBER_STATUS = `${API_URL}/common/status/team-member-status`;

export const API_COMMON_QUOTES_STATUS = `${API_URL}/common/status/quote-status`;

export const API_CUSTOMER_TITLES = `${API_URL}/common/status/customer-titles`;

export const API_CALCULATE_FINANCES = `${API_URL}/common/calculate-finances`;

export const API_CALCULATE_FINANCES_V2 = `${BASE_API_URL}/${'v2'}/common/calculate-finances`;

export const API_LAST_UPDATE = `${API_URL}/common/check-updates`;

// TEAM APIS
export const API_TEAM_MEMBERS = `${API_URL}/team-members`;

export const API_GET_TEAM_MEMBER_BY_ID = `${API_URL}/team-members`;

export const API_ADD_TEAM_MEMBER = `${API_URL}/team-members`;

export const API_COMMON_CUSTOMER_STATUS = `${API_URL}/common/status/customer-status`;

// CUSTOMER APIS
export const API_CUSTOMERS = `${API_URL}/customers`;

export const API_CUSTOMER_SITES = (customerUuid: string) =>
  `${API_CUSTOMERS}/${customerUuid}/sites`;

export const API_CUSTOMER_SITES_UPDATE = (
  customerUuid: string,
  siteUuid: string,
) => `${API_CUSTOMERS}/${customerUuid}/sites/${siteUuid}`;

export const API_CUSTOMER_NOTES = (customerUuid: string) =>
  `${API_CUSTOMERS}/${customerUuid}/notes`;

export const API_CUSTOMER_NOTES_UPDATE = (
  customerUuid: string,
  noteUuid: string,
) => `${API_CUSTOMERS}/${customerUuid}/notes/${noteUuid}`;

// CONTACTS API (v2)
const API_V2_URL = `${BASE_API_URL}/v2`;
export const API_CONTACTS = `${API_V2_URL}/contacts`;
export const API_CONTACT_UPDATE = (contactUuid: string) =>
  `${API_CONTACTS}/${contactUuid}`;
export const API_CONTACT_DELETE = (contactUuid: string) =>
  `${API_CONTACTS}/${contactUuid}`;

export const API_CUSTOMERS_EXPORT = `${API_URL}/customers/export`;

export const API_UPDATE_TEAM_MEMBER = `${API_URL}/team-members`;

export const DELETE_IMAGE = `${API_URL}`;

export const API_PRODUCTS = `${API_URL}/products`;

export const API_PRODUCTS_IMPORT = `${API_URL}/products/import`;

export const API_PRODUCTS_IMPORT_HISTORY = `${API_URL}/products/import/history`;
export const API_PRODUCTS_IMPORT_HISTORY_ALL = `${API_URL}/products/import/history/all`;

export const API_PRODUCTS_EXPORT = `${API_URL}/products/export`;

// QUOTE APIS
export const API_GET_QUOTES_V2 = `${BASE_API_URL}/${'v2'}/quotes`;

export const API_GET_QUOTES = `${API_URL}/quotes`;

export const API_CREAT_QUOTE = `${BASE_API_URL}/${'v2'}/quotes`;

export const API_UPDATE_QUOTE = `${API_URL}/quotes`;

export const API_UPDATE_QUOTE_V2 = `${BASE_API_URL}/${'v2'}/quotes`;

export const API_QUOTE_SEND_EMAIL_V2 = (quoteUuid: string) =>
  `${BASE_API_URL}/${'v2'}/quotes/${quoteUuid}/send-email`;

export const API_QUOTE_REVISIONS_V2 = (quoteUuid: string) =>
  `${BASE_API_URL}/${'v2'}/quotes/${quoteUuid}/revisions`;

// JOBS APIS
export const API_JOBS = `${API_URL}/jobs`;
export const API_CREATE_JOB_V2 = `${BASE_API_URL}/${'v2'}/jobs`;
export const API_UPDATE_JOB_V2 = `${BASE_API_URL}/${'v2'}/jobs`;
export const API_GET_JOB_STATUS = `${API_URL}/common/status/job-status`;
export const API_GET_JOB_TYPE = `${API_URL}/common/status/job-type`;
export const API_GET_JOB_RECURRING_TYPE = `${API_URL}/common/status/job-recurring-type`;

// Schedule Jobs APIS
export const API_SCHEDULE_JOBS = `${API_URL}/jobs/job-schedules`;

// EXPENSES APIS
export const API_ADD_EXPENSES = `${API_URL}/expenses`;
export const API_EXPENSES = `${API_URL}/expenses`;

// timesheet APIS

export const API_TIMESHEETS = `${API_URL}/timesheets`;
export const API_TIMESHEET_CATEGORY = `${API_URL}/common/status/timesheet-category`;
export const API_TIMESHEET_REPORTS_SUMMARY = `${API_URL}/timesheets/reports/summary`;
export const API_TIMESHEET_REPORTS_SUMMARY_EXPORT = `${BASE_API_URL}/v2/timesheets/reports/summary/export`;
export const API_TIMESHEET_REPORTS_OVERVIEW_EXPORT = `${BASE_API_URL}/v2/timesheets/reports/overview`;
export const API_TIMESHEET_REPORTS_OVERVIEW = `${API_URL}/timesheets/reports/overview`;

// PERFORMANCE DASHBOARD
export const API_PERFORMANCE_DASHBOARD = `${BASE_API_URL}/v2/reports/financial/dashboard`;
export const API_PERFORMANCE_DASHBOARD_EXPORT = `${BASE_API_URL}/v2/reports/financial/export`;

// INVOICE REPORTS
export const API_INVOICE_REPORTS_SUMMARY = `${BASE_API_URL}/v2/invoices/reports/summary`;
export const API_INVOICE_REPORTS_SUMMARY_EXPORT = `${BASE_API_URL}/v2/invoices/reports/summary/export`;

// ENQUIRY APIS
export const API_ENQUIRY = `${API_URL}/enquiries`;

export const API_GET_ENQUIRY_STATUS = `${API_URL}/common/status/enquiry-status`;

// INVOICE APIs
export const API_INVOICE = `${API_URL}/invoices`;

export const API_INVOICE_COMMON = `${API_URL}`;

export const API_INVOICE_SYNC_XERO = `${API_URL}/xero/sync-invoice`;

// V2 INVOICE APIs
export const API_V2_INVOICE_VOID = (invoiceUuid: string) =>
  `/v2/invoices/${invoiceUuid}/void`;

export const API_INVOICE_SEND_EMAIL_V2 = (invoiceUuid: string) =>
  `${BASE_API_URL}/${'v2'}/invoices/${invoiceUuid}/send-email`;

export const API_FORGOT_PASSWORD = `${API_URL}/auth/forgot-password`;

export const API_RESET_PASSWORD = `${API_URL}/auth/reset-password`;

export const API_EXPORT = `${API_URL}/common/exports`;
export const API_ACCOUNT_BILLING = `${API_URL}/subscription`;

export const API_SUBSCRIPTION_GET_DETAIL = `${API_URL}/subscription/get-details`;

export const API_SUBSCRIPTION_CHECKOUT = `${API_URL}/subscription/create`;

export const API_SUBSCRIPTION_CANCEL = `${API_URL}/subscription/cancel`;

export const API_CHANGE_MY_CARD = `${API_URL}/subscription/change-card-details`;

export const API_SUBSCRIPTION_INVOICE_DOWNLOAD_V2 = (invoiceId: string) =>
  `${BASE_API_URL}/v2/subscription/payments/${invoiceId}/documents`;

export const API_PUSH_NOTIFICATION = `${API_URL}/push-notification`;
export const API_PUSH_NOTIFICATION_COUNT = `${API_URL}/push-notification/count`;
export const API_PUSH_NOTIFICATION_MARK = `${API_URL}/push-notification/mark-as-read`;
export const API_PUSH_NOTIFICATION_MARK_ALL_AS_READ = `${BASE_API_URL}/${'v2'}/push-notifications/mark-all-as-read`;

export const API_SUPPLIER = `${API_URL}/suppliers`;

// INVENTORY APIs
export const API_FETCH_INVENTORY = `${API_URL}/inventories`;
export const API_FETCH_ALL_INVENTORY = `${API_URL}/inventories/all/inventories`;
export const API_FETCH_MAIN_INVENTORIES = `${API_URL}/inventories/details/main`;
export const API_FETCH_VAN_INVENTORIES = `${API_URL}/inventories/details/van`;
export const API_FETCH_INVENTORY_ITEMS = `${API_URL}/inventories/details/common`;
export const API_TRANSFER_INVENTORIES = `${API_URL}/inventories/transfers`;
export const API_INVENTORIES_DETAILS = `${API_URL}/inventories/details`;
export const API_COMMON_INV_ADJ_DET_REASONS = `${API_URL}/common/status/inventory-adjustment-detail-reason`;

// PURCHASE ORDER APIS
export const API_GET_PURCHASE_ORDERS = `${API_URL}/purchase-orders`;

export const API_CREAT_PURCHASE_ORDER = `${API_URL}/purchase-orders`;

export const API_CREAT_PURCHASE_ORDER_CORYS = `${API_URL}/purchase-orders/store-corys`;

export const API_UPDATE_PURCHASE_ORDER = `${API_URL}/purchase-orders`;

export const API_UPDATE_PURCHASE_ORDER_CORYS = (uuid: string) =>
  `${API_URL}/purchase-orders/${uuid}/update-corys`;

export const API_GET_PURCHASE_ORDER_STATUS = `${API_URL}/common/status/purchase-order`;

// PURCHASE ORDER - USER INVENTORY
export const API_PURCHASE_ORDERS_USER_INVENTORY = `${API_URL}/purchase-orders/user-inventory`;

// EMAIL TEMPLATE APIS
export const API_EMAIL_TEMPLATE_SETTINGS = `${API_URL}/company/email-templates/email-sender/get`;
export const API_EMAIL_TEMPLATE_SETTINGS_SET = `${API_URL}/company/email-templates/email-sender/set`;
export const API_EMAIL_TEMPLATE_SENDER_LIST = `${API_URL}/common/email-senders`;
export const API_EMAIL_TEMPLATE = `${API_URL}/company/email-templates`;

// REFER A FRIEND APIS
export const API_REFER_A_FRIEND = `${API_URL}/referrals`;

// Permission APIS
export const API_GET_PERMISSIONS = `${API_URL}/common/get-all-permissions`;

// SUPPLIER APIS
export const API_GET_SUPPLIERS = `${API_URL}/suppliers?type=0&type=1`;
export const API_GET_SYSTEM_SUPPLIERS = `${API_URL}/system-suppliers`;
export const API_SUPPLIER_DOCUMENTS_IMPORT = `${API_URL}/supplier-documents/import`;
export const API_SUPPLIER_DOCUMENTS = `${API_URL}/supplier-documents`;
export const API_GET_ALL_SUPPLIERS = `${API_URL}/suppliers`;
export const API_SUPPLIERS_LIST = `${API_URL}/suppliers/list`;
export const API_SUPPLIER_BRANCHES_LIST = `${API_URL}/supplier-branches/list`;
export const API_INTEGRATION_PROVIDER_BRANCHES = `${API_URL}/integration-provider-branches`;
export const API_SUPPLIER_IMPORT_HISTORY = `${API_URL}/suppliers/import/history`;
export const API_SUPPLIER_IMPORT_HISTORY_ALL = `${API_URL}/suppliers/import/history/all`;
export const API_CUSTOMER_IMPORT_HISTORY = `${API_URL}/customers/import/history`;
export const API_CUSTOMER_IMPORT_HISTORY_ALL = `${API_URL}/customers/import/history/all`;
export const API_CUSTOMER_IMPORT_ERROR_REPORT = (uuid: string) =>
  `${API_URL}/customers/import/${uuid}/error-report`;
export const API_SUPPLIER_IMPORT_HIDE = `${API_URL}/suppliers/import`;
export const API_SUPPLIER_VALIDATE_PRODUCTS = `${API_URL}/suppliers`;
export const API_SUPPLIER_PRICE_BOOK_LATEST = (supplierUuid: string) =>
  `${API_URL}/suppliers/${supplierUuid}/price-book/latest`;
export const API_SUPPLIER_PRICE_BOOK_DELETE = (
  supplierUuid: string,
  pricebookUuid: string,
) => `${API_URL}/suppliers/${supplierUuid}/price-book/delete/${pricebookUuid}`;

export const API_GET_MERGED_SUPPLIERS = `${BASE_API_URL}/${'v2'}/suppliers/get-merged-suppliers`;

// INTEGRATION SUPPLIERS APIS
export const API_INTEGRATION_SUPPLIERS = `${API_URL}/integration-suppliers`;

// CUSTOMER PORTAL APIS
export const API_CUSTOMER_PORTAL = `${API_URL}/customer-portal`;

// PROCESS MODULE NUMBER API
export const API_PROCESS_MODULE_NUMBER = `${API_URL}/common/next-number`;

// TRADE WORKFLOW
export const API_VARIATIONS = `${API_URL}/jobs`;

// GET COMPANY DETAILS
export const API_GET_COMPANY_DETAILS = `${API_URL}/company/settings/get-settings`;

// ENTITY SETTINGS API
export const API_ENTITY_SETTINGS = `${BASE_API_URL}/${'v2'}/company/settings/entity-settings`;
export const API_ENTITY_SETTINGS_UPDATE = `${BASE_API_URL}/${'v2'}/company/settings/entity-settings/update`;
export const API_QUOTE_ENTITY_SETTINGS = `${BASE_API_URL}/${'v2'}/company/settings/entity-settings/quote`;
export const API_INVOICE_ENTITY_SETTINGS = `${BASE_API_URL}/${'v2'}/company/settings/entity-settings/invoice`;
export const API_INVOICE_ENTITY_SETTINGS_BY_JOB_ID = `${BASE_API_URL}/${'v2'}/company/settings/entity-settings/invoice/job_id`;

// API REPORTS
export const API_ALL_JOBS = `${API_URL}/jobs/all/jobs`;

export const API_JOB_REPORT = `${API_URL}/jobs`;

export const API_TERMS_ACCEPTANCE = `${API_URL}/terms/accept`;

// ABOUT WORK APIS
export const API_ABOUT_WORK = `${API_URL}/dashboard/about-work`;

// JOB SUMMARY
export const API_JOB_SUMMARY = `${API_URL}/dashboard/jobs/summary`;

export const API_DASHBOARD_JOBS_STATS = `${API_URL}/dashboard/jobs/stats`;

export const API_DASHBOARD_INVOICE_STATES = `${API_URL}/dashboard/invoices/stats`;

export const API_DASHBOARD_QUOTES_STATS = `${API_URL}/dashboard/quotes/stats`;

export const API_DASHBOARD_POS_STATS = `${API_URL}/dashboard/pos/stats`;

export const API_DASHBOARD_ONBOARD_TASKS = `${API_URL}/dashboard/onboard-tasks`;

export const API_ONBOARD_STEP = `${API_URL}/onboard/step`;

export const API_CURRENCY_LIST = `${API_URL}/currency/list`;

// ASSOCIATED RECORDS API
export const API_ASSOCIATED_RECORDS = `${API_URL}/common/associated-records`;

// V2 SECTIONS API
export const API_CREATE_SECTION = (_quoteUuid?: string) =>
  `${BASE_API_URL}/${'v2'}/sections`;
export const API_CREATE_JOB_SECTION = (jobUuid: string) =>
  `${BASE_API_URL}/${'v2'}/jobs/${jobUuid}/sections`;

// V2 JOB PHASES API
export const API_JOB_PHASES = (jobUuid: string) =>
  `${BASE_API_URL}/${'v2'}/jobs/${jobUuid}/phases`;
export const API_JOB_SUPPLIER_DOCUMENTS_FOR_INVOICE = (jobUuid: string) =>
  `${BASE_API_URL}/v2/jobs/${jobUuid}/supplier-documents-for-invoice`;
export const API_JOB_UNASSIGNED_ITEMS_FOR_INVOICE = (jobUuid: string) =>
  `${BASE_API_URL}/v2/jobs/${jobUuid}/unassigned-items-for-invoice`;
export const API_CREATE_JOB_PHASE = (jobUuid: string) =>
  `${BASE_API_URL}/${'v2'}/jobs/${jobUuid}/phases`;
export const API_UPDATE_PHASE_SERVICES = (phaseUuid: string) =>
  `${BASE_API_URL}/${'v2'}/phases/${phaseUuid}`;
export const API_UPDATE_PHASE_BODY = (phaseUuid: string) =>
  `${BASE_API_URL}/${'v2'}/phases/${phaseUuid}/update-phase-body`;
export const API_DELETE_PHASE = (phaseUuid: string) =>
  `${BASE_API_URL}/${'v2'}/phases/${phaseUuid}`;
export const API_DELETE_PHASE_SECTION = (phaseUuid: string) =>
  `${BASE_API_URL}/${'v2'}/phases/${phaseUuid}`;
export const API_DELETE_PHASE_SECTION_ITEM = (phaseUuid: string) =>
  `${BASE_API_URL}/${'v2'}/phases/${phaseUuid}`;
export const API_UPDATE_SECTION_ITEM = `${BASE_API_URL}/${'v2'}/sections/update_section_item`;
export const API_UPDATE_SECTION_BODY = `${BASE_API_URL}/${'v2'}/sections/update-section-body`;
export const API_CREATE_LINE_ITEM = `${BASE_API_URL}/${'v2'}/sections/create-line-item`;
export const API_DELETE_LINE_ITEM = `${BASE_API_URL}/${'v2'}/sections/delete-line-item`;
export const API_CREATE_TASK = `${BASE_API_URL}/${'v2'}/tasks/create`;
export const API_UPDATE_TASK = (taskUuid: string) =>
  `${BASE_API_URL}/${'v2'}/tasks/${taskUuid}`;
export const API_DELETE_TASK = (taskUuid: string) =>
  `${BASE_API_URL}/${'v2'}/tasks/${taskUuid}`;
export const API_GET_TASK = (taskUuid: string) =>
  `${BASE_API_URL}/${'v2'}/tasks/${taskUuid}`;
export const API_FINISH_TASK = (taskUuid: string) =>
  `${BASE_API_URL}/${'v2'}/tasks/${taskUuid}/finish`;
export const API_UPDATE_COLUMN_VISIBILITY = `${BASE_API_URL}/${'v2'}/sections/update-column-visibility`;
export const API_DELETE_SECTION = (sectionUuid: string) =>
  `${BASE_API_URL}/${'v2'}/quotes/sections/${sectionUuid}`;
export const API_UPDATE_QUOTE_BODY = `${BASE_API_URL}/${'v2'}/quotes/update-quote-body`;

// V2 ACCOUNTING
export const API_V2_ACCOUNTING_PROVIDERS = `${BASE_API_URL}/${'v2'}/accounting/providers`;
export const API_V2_ACCOUNTING_CONNECT = (provider: string) =>
  `${BASE_API_URL}/${'v2'}/accounting/${provider}/connect`;
export const API_V2_ACCOUNTING_STATUS = (provider: string) =>
  `${BASE_API_URL}/${'v2'}/accounting/${provider}/status`;
export const API_V2_ACCOUNTING_DISCONNECT = (provider: string) =>
  `${BASE_API_URL}/${'v2'}/accounting/${provider}/disconnect`;
export const API_V2_ACCOUNTING_COMPANY_PROVIDER_ACCOUNTS = (
  companyId: string,
  providerId: string,
) =>
  `${BASE_API_URL}/${'v2'}/accounting/company/${companyId}/provider/${providerId}/accounts`;

export const API_V2_ACCOUNTING_ACCOUNT_SCOPES = `${BASE_API_URL}/${'v2'}/accounting/account-scopes`;

export const API_V2_ACCOUNTING_SETTINGS = `${BASE_API_URL}/${'v2'}/accounting/settings`;

export const API_V2_ACCOUNTING_PROVIDER_ACCOUNTS = `${BASE_API_URL}/${'v2'}/accounting/provider-accounts`;

export const API_V2_ACCOUNTING_MAPPINGS_BULK = `${BASE_API_URL}/${'v2'}/accounting/mappings/bulk`;

export const API_V2_ACCOUNTING_REFRESH = (provider: string) =>
  `${BASE_API_URL}/${'v2'}/accounting/${provider}/refresh-data`;

// Accounting integration (provider-agnostic)
export const API_V2_ACCOUNTING_ENTITY_SYNC_STATUS = `${BASE_API_URL}/${'v2'}/accounting/entity-sync-status`;
export const API_V2_ACCOUNTING_SYNC_ENTITY = `${BASE_API_URL}/${'v2'}/accounting/sync-entity`;

// V2 VARIATIONS API
export const API_CREATE_VARIATION = (jobUuid: string) =>
  `${BASE_API_URL}/${'v2'}/jobs/${jobUuid}/variations`;
export const API_GET_VARIATIONS = (jobUuid: string) =>
  `${BASE_API_URL}/${'v2'}/jobs/${jobUuid}/variations`;
export const API_GET_ALL_TIMESHEETS = `${BASE_API_URL}/${'v2'}/timesheets`;
export const API_UPDATE_VARIATION = (jobUuid: string, variationUuid: string) =>
  `${BASE_API_URL}/${'v2'}/jobs/${jobUuid}/variations/${variationUuid}`;

// V2 INVENTORY APIs
export const API_ADD_INVENTORY_ITEMS = (inventoryUuid: string) =>
  `${BASE_API_URL}/v2/inventories/${inventoryUuid}/details`;

// V2 TUTORIAL VIDEOS API
export const API_TUTORIAL_VIDEOS = `${BASE_API_URL}/v2/tutorial-videos`;
export const API_TUTORIAL_VIDEOS_HIDE_MODULE = `${BASE_API_URL}/v2/tutorial-videos/hide-module`;

const WEBSITE_URL =
  process.env.NEXT_PUBLIC_WEBSITE_URL || 'https://www.zynoff.com';

export const TERMS_CONDITIONS_URL = `${WEBSITE_URL}/terms-conditions`;
export const PRIVACY_POLICY_URL = `${WEBSITE_URL}/privacy-policy`;
export const CONTACT_URL = `${WEBSITE_URL}/contact`;
